var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9641 20.4933C39.9641 31.4843 31.0546 40.3938 20.0636 40.3938C9.07294 40.3938 0.163086 31.4843 0.163086 20.4933C0.163086 9.50243 9.07294 0.592773 20.0636 0.592773C31.0546 0.592773 39.9641 9.50243 39.9641 20.4933Z",
    fill: "#1BA27A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4033 10.6279H10.5596V15.1772H17.7068V21.8638H22.2561V15.1772H29.4033V10.6279Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.025 22.5755C14.1126 22.5755 9.31913 21.6398 9.31913 20.4853C9.31913 19.3311 14.1124 18.3952 20.025 18.3952C25.9374 18.3952 30.7307 19.3311 30.7307 20.4853C30.7307 21.6398 25.9374 22.5755 20.025 22.5755ZM32.0459 20.8338C32.0459 19.3452 26.664 18.1387 20.025 18.1387C13.3862 18.1387 8.00391 19.3452 8.00391 20.8338C8.00391 22.1446 12.1772 23.2368 17.7074 23.4788V33.0776H22.2562V23.4826C27.829 23.2481 32.0459 22.1514 32.0459 20.8338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.09b207adc302a8d0cbfb6c40dad65623.svg";
export { ForwardRef as ReactComponent };